import type { PlatformFeatureType } from "@/types/graphql/partner.generated";
import { hasPlatformFeature } from "../model/platformFeatures";
import { useCurrentPlatformQuery } from "./useCurrentPlatformQuery";

/**
 * Фичефлаг текущей платформы (включает админ). Пока платформа грузится,
 * флаг считается выключенным: вкладки и карточки за флагом появятся
 * после ответа, а не мигнут и исчезнут.
 */
export const usePlatformFeature = (feature: PlatformFeatureType): boolean => {
  const { data } = useCurrentPlatformQuery();
  return hasPlatformFeature(data?.currentPlatform?.features, feature);
};
